// Fast tile providers - using Stamen and MapTiler free tiers
export const TILE_PROVIDERS = {
  osm: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  satellite: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
  terrain: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
  dark: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
}

export const DEFAULT_ZOOM = 15
export const DEFAULT_CENTER: [number, number] = [52.37, 4.9] // Amsterdam
export const FOLLOW_THRESHOLD = 100 // meters
export const FOLLOW_TIMEOUT = 12000 // ms
export const TILE_SIZE = 256
export const MAX_ZOOM = 19
export const KEEP_BUFFER = 3
